import { useEffect, useMemo, useRef, useState } from 'react';

export interface Options {
  leftTime: number;
  interval?: number;
  onEnd?: () => void;
}

const calcLeft = (target: number) => {
  if (!target) {
    return 0;
  }

  const left = target - Date.now();

  return left < 0 ? 0 : left;
};

function useLatest<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;

  return ref;
}

/** 从aHooks抄来的，做了一些改动 */
const useCountdown = (options: Options) => {
  const { leftTime, interval = 1000, onEnd } = options || {};
  const [target, setTarget] = useState(Date.now() + leftTime);

  const [timeLeft, setTimeLeft] = useState(() => calcLeft(target));

  const onEndRef = useLatest(onEnd);

  const reset = () => {
    setTarget(Date.now() + leftTime);
  };

  useEffect(() => {
    if (!target) {
      setTimeLeft(0);
      return;
    }

    // 立即执行一次
    setTimeLeft(calcLeft(target));

    const timer = setInterval(() => {
      const targetLeft = calcLeft(target);
      setTimeLeft(targetLeft);
      if (targetLeft === 0) {
        clearInterval(timer);
        onEndRef.current?.();
      }
    }, interval);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, interval]);

  const leftSeconds = useMemo(() => Math.ceil(timeLeft / 1000), [timeLeft]);

  return [leftSeconds, reset] as const;
};

export default useCountdown;
